globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Social = appCustomerSpace.Controllers.Social || {};

appCustomerSpace.Controllers.Social.SocialPostsFormController = (function (superClass) {

  utils.extend(SocialPostsFormController, superClass);

  function SocialPostsFormController() {
    this.$webpageShareImage = $('.webpage-share-image');
    this.$webpageLabel = $('.webpage-label');
    this.$webpageUrl = $('.webpage-url');

    return SocialPostsFormController.__super__.constructor.apply(this, arguments);
  }

  $.extend(SocialPostsFormController.prototype, {
    init: function () {
      return SocialPostsFormController.__super__.init.apply(this, arguments);
    },
    editCommentary: function () {
      var controller = this;

      controller._formEvents();
      controller._reshareCommentaryAIGenerationEvents();
    },
    editMedia: function () {
      var controller = this;
      controller._formEvents();

      if ($('iframe').length) {
        appCustomerSpace.Loader().start({ $container: $('.preview-container'), options: { text: false } });
      }

      $('iframe').on('load', function () {
        appCustomerSpace.Loader().stop({ $container: $('.preview-container') })
      });

      window.addEventListener('message', function (event) {
        if (event.data.type === 'setHeight') {
          $('iframe').css('height', event.data.height + 'px');
        }
      });

      $('body').on('customer-space--image-content:updated customer-space--image-content:deleted', function () {
        var $iframe = $('iframe');
        if ($iframe.length === 0) return;

        appCustomerSpace.Loader().start({ $container: $('.preview-container'), options: { text: false } });
        $iframe.attr('src', $iframe.attr('src'));
      });
    },
    editMulticast: function () {
      $('input[name="social_post_form[publishing_date]"]').on('change', function () {
        var val = $(this).val();
        $('.publishing_forced_date_group').toggle(val === 'specific_day');
        $('.publishing_priority_group').toggle(val === 'automatic');
        $('.publishing_date_now_alert').toggle(val === 'now');

        if (val !== 'specific_day' && val !== 'automatic' && val !== 'now') {
          $('.publishing_forced_date_group, .publishing_priority_group, .publishing_date_now_alert').hide();
        }
      });
    },
    reloadForm: function (response) {
      if (response && response.form_html) {
        $('form.edit_social_post_form').replaceWith($(response.form_html));
        appCustomerSpace.LimitlessPlugins.initPlugins($('.edit_social_post_form'));
        appCustomerSpace.Plugins.initPlugins($('.edit_social_post_form'));
        appCustomerSpace.Modules.initModules($('.edit_social_post_form'));
      }
    },
    _reshareCommentaryAIGenerationEvents: function () {
      var controller = this;

      $(document).on('click', '.generate-reshare-commentary', function () {
        var $btn = $(this);
        var url = $btn.data('url');
        var originalHtml = $btn.html();

        $btn.prop('disabled', true).html('<i class="icon-spinner2 spinner position-left"></i> ' + $btn.data('loadingText'));

        $.ajax({
          url: url + '.json',
          type: 'PATCH',
          data: { current_step: 'reshare_commentary_ai_generation', 'social_post_form[submit]': '' },
          success: function (data) {
            if (data.errors) {
              new PNotify({ icon: 'icon-cross2', title: data.errors.join(', '), type: 'error', delay: 3000 });
              $btn.prop('disabled', false).html(originalHtml);
            } else if (data.reshare_commentary) {
              var $textarea = $('#social_post_form_reshare_commentary');
              $textarea.val(data.reshare_commentary);
              appCustomerSpace.Modules.ResizeTextAreaToFitContent.init($('#social_post_form_reshare_commentary'));
              $btn.prop('disabled', false).html(originalHtml);
            }
          },
          error: function () {
            $btn.prop('disabled', false).html(originalHtml);
          }
        });
      });
    },
    _formEvents: function () {
      var controller = this;

      $('body').on('change', 'form.edit_social_post_form .save-on-change', function () {
        var $form = $(this).closest('form');
        var $element = $(this);

        $form.find('input#social_post_form_incoming_changes').val(true);

        if ($element.hasClass('reload-iframe')) {
          appCustomerSpace.Loader().start({ $container: $('.preview-container'), options: { text: false } });
        }
        appCustomerSpace.Loader().start({ $container: controller.$webpageShareImage, options: { text: $form.data('loadingText') } });

        $.ajax({
          url: $form.attr('action') + '.json',
          type: $form.attr('method'),
          data: $form.serialize(),
          success: function (response) {
            if (response.form_html) {
              controller.reloadForm(response);
            }

            controller.$webpageLabel.val(response.webpage_label);
            controller.$webpageUrl.val(response.webpage_url);

            if (response.webpage_share_image_url != null) {
              controller.$webpageShareImage.css('background-image', 'url(' + response.webpage_share_image_url + ')');
              controller.$webpageShareImage.find('.no-image-text').hide();
            } else {
              controller.$webpageShareImage.css('background-image', '');
              controller.$webpageShareImage.find('.no-image-text').show();
            }

            appCustomerSpace.Loader().stop({ $container: controller.$webpageShareImage });
          }
        });
      });
    }
  });

  return SocialPostsFormController;

})(appCustomerSpace.Controllers.Social.MainController);
